import { render } from "./DynamicAppVideoElement.vue.js?vue&type=template&id=212ac7bc!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppVideoElement.vue?vue&type=template&id=212ac7bc"
import script from "./DynamicAppVideoElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppVideoElement.vue?vue&type=script&lang=js"
export * from "./DynamicAppVideoElement.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppVideoElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/dynamic-app-elements/display/DynamicAppVideoElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "212ac7bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('212ac7bc', __exports__)) {
    api.reload('212ac7bc', __exports__)
  }
  
  module.hot.accept("./DynamicAppVideoElement.vue.js?vue&type=template&id=212ac7bc!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DynamicAppVideoElement.vue?vue&type=template&id=212ac7bc", () => {
    api.rerender('212ac7bc', render)
  })

}


export default __exports__